import { useSyncExternalStore, useEffect, useCallback } from 'react'

const STORAGE_KEY = 'pg19_senior_mode'
const MD_BREAKPOINT = 768

function isMobileOrPwa(): boolean {
  if (typeof window === 'undefined') return false
  const isMobile = window.innerWidth < MD_BREAKPOINT
  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0
  return isMobile || (isStandalone && isTouchDevice)
}

function subscribe(callback: () => void) {
  window.addEventListener('pg19:senior-changed', callback)
  return () => window.removeEventListener('pg19:senior-changed', callback)
}

function getSnapshot(): boolean {
  if (!isMobileOrPwa()) return false
  return localStorage.getItem(STORAGE_KEY) === 'true'
}

function getServerSnapshot(): boolean {
  return false
}

/**
 * Senior mode — task-first UI для пенсионеров (50%+ аудитории).
 *
 * Desktop: всегда false (pro mode).
 * Mobile/PWA: false по умолчанию, включается по клику на лупу.
 *
 * useSyncExternalStore гарантирует что все компоненты синхронизированы:
 * toggle() в одном компоненте → ре-рендер во всех.
 */
export function useSeniorMode() {
  const senior = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
  const enabled = isMobileOrPwa()

  useEffect(() => {
    document.documentElement.dataset.senior = String(enabled ? senior : false)
  }, [enabled, senior])

  const toggle = useCallback(() => {
    if (!isMobileOrPwa()) return
    const current = localStorage.getItem(STORAGE_KEY) === 'true'
    localStorage.setItem(STORAGE_KEY, String(!current))
    window.dispatchEvent(new Event('pg19:senior-changed'))
  }, [])

  return { senior, toggle, enabled }
}
